<template>
  <FormModal :visible="visible" :header="'Create work area'" :size="'2xl'" :clickOutside="true" @close="$emit('close')">
    <template #content>
      <WorkAreaForm @close="$emit('close')" />
    </template>
  </FormModal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
// components
import FormModal from "@/components/modals/FormModal.vue";
import WorkAreaForm from "@/features/workAreas/WorkAreaForm.vue";

export default defineComponent({
  name: "WorkAreaFormModal",
  components: {
    FormModal,
    WorkAreaForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  emits: { close: null },
  setup() {
    return {};
  }
});
</script>
